<template>

  <div>

    <type-list-add-new
      :is-add-new-type-sidebar-active.sync="isAddNewTypeSidebarActive"
      :categories-options="categoriesOptions"
      @refetch-data="refetchData"
    />


    <!-- Filters -->
    <types-list-filters
        :category-filter.sync="categoryFilter"
        :categories-filter-options="categoriesOptions"
    />

    <!-- Table Container Card -->
    <b-card no-body class="mb-0">

      <div class="loading_page" v-if="requestStatus">
        <orbit-spinner
            :animation-duration="1000"
            :size="100"
            :color="'#0e96b1'"
        />
      </div>

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col cols="12" md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
            <label>{{ $t('Show') }}</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>{{ $t('entries') }}</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Search..."
              />


              <b-button v-if="$store.getters['auth/menus'].includes('types.create')"
                        variant="primary" @click="isAddNewTypeSidebarActive = true">
                <span class="text-nowrap">{{ $t('Create Type')}}</span>
              </b-button>

            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refTypeListTable"
        class="position-relative"
        :items="fetchTypes"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc">


<!--        &lt;!&ndash; Column: name &ndash;&gt;-->
<!--        <template #cell(name)="data">-->
<!--          {{ data.item.name[$i18n.locale] }}-->
<!--        </template>-->


<!--        &lt;!&ndash; Column: description &ndash;&gt;-->
<!--        <template #cell(description)="data">-->
<!--          {{ data.item.description[$i18n.locale] }}-->
<!--        </template>-->

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown variant="link" class="actionIcon"
            no-caret :right="$store.state.appConfig.isRTL">

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item v-if="$store.getters['auth/menus'].includes('types.update')" :to="{ name: 'types.update', params: { id: data.item.id } }">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">{{ $t('Edit') }}</span>
            </b-dropdown-item>

            <b-dropdown-item v-else>
              <span class="align-middle ml-50">{{ $t('Edit Not Permitted') }}</span>
            </b-dropdown-item>

            <b-dropdown-item v-if="$store.getters['auth/menus'].includes('types.destroy')" @click="removeType(data.item.id)">
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">{{ $t('Delete')}}</span>
            </b-dropdown-item>

            <b-dropdown-item v-else>
              <span class="align-middle ml-50">{{ $t('Delete Not Permitted') }}</span>
            </b-dropdown-item>

          </b-dropdown>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">{{ $t('Showing') }} {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} {{$t('entries')}}</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalTypes"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { ref, onUnmounted } from '@vue/composition-api'

import useTypesList from '@/views/modules/type/types-list/useTypesList'
import typeStoreModule from '@/views/modules/type/typeStoreModule'
import TypeListAddNew from '@/views/modules/type/types-list/TypeListAddNew'
import TypesListFilters from '@/views/modules/type/types-list/TypesListFilters'
import { OrbitSpinner } from 'epic-spinners'

export default {
  components: {
    TypesListFilters,
    TypeListAddNew,
    OrbitSpinner,

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,

    vSelect,
  },
  setup(props, {root}) {

    const TYPE_APP_STORE_MODULE_NAME = 'app-type'

    // Register module
    if (!store.hasModule(TYPE_APP_STORE_MODULE_NAME))
          store.registerModule(TYPE_APP_STORE_MODULE_NAME, typeStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(TYPE_APP_STORE_MODULE_NAME))
            store.unregisterModule(TYPE_APP_STORE_MODULE_NAME)
    })

    const isAddNewTypeSidebarActive = ref(false)


    const {

      fetchTypes,
      tableColumns,
      perPage,
      currentPage,
      totalTypes,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refTypeListTable,
      refetchData,
      categoriesOptions,
      typesCategoriesFilter,
        categoryFilter,
      removeType,

      // UI
      requestStatus,

    } = useTypesList(root)



    return {

      // Sidebar
      isAddNewTypeSidebarActive,
      requestStatus,
      fetchTypes,
      tableColumns,
      perPage,
      currentPage,
      totalTypes,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refTypeListTable,
      categoriesOptions,
      categoryFilter,
      removeType,
      typesCategoriesFilter,
      refetchData,

    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.actionIcon > button {
  padding: 0;
}
</style>
